import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { PORTAL_CRUD_ACTION_CREATORS } from '../actions/portal_actions';

export const portalsRestCrudThunksForBuyer = new RestCrudThunks(
	'client_portal_link',
	'client_portal_link',
	'client_portal_link',
	'client_portal_links',
	PORTAL_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'client_portal_links/'
);

export const portalsCrudThunksForSupplier = new RestCrudThunks(
	'client_portal_link',
	'client_portal_link',
	'client_portal_link',
	'client_portal_links',
	PORTAL_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'client_portal_links/'
);
